import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";

const KIND_EMOJI = { birthday: "🎂", work_anniversary: "🚀", wedding_anniversary: "💐", first_day: "👋" };
const KIND_LABEL = { birthday: "Birthday", work_anniversary: "Work anniversary", wedding_anniversary: "Anniversary", first_day: "First day · Welcome!" };

export default function TodaysCelebrations() {
  const { activeWorkspaceId } = useAuth();
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (!activeWorkspaceId) return;
    (async () => {
      try {
        const { data } = await api.get(`/workspaces/${activeWorkspaceId}/celebrations/today`);
        setItems(data.items || []);
      } catch { /* silent */ }
    })();
  }, [activeWorkspaceId]);
  if (!items.length) return null;
  return (
    <section className="border border-amber-300" style={{ background: "linear-gradient(90deg,#fef3c7,#fce7f3,#fef3c7)" }} data-testid="todays-celebrations">
      <div className="px-4 py-3 flex items-center gap-2 border-b border-amber-300/60">
        <span className="text-lg">🎉</span>
        <div className="label-eyebrow" style={{ color: "#7c2d12" }}>Today&apos;s celebrations</div>
      </div>
      <div className="px-4 py-4 flex items-center gap-4 flex-wrap">
        {items.map((it, i) => (
          <div key={`${it.user_id || it.employee_id}-${i}`} className="flex items-center gap-3 bg-white/60 border border-amber-200 px-3 py-2" data-testid={`celebration-${it.kind}-${i}`}>
            {it.avatar_url ? (
              <img src={it.avatar_url} alt="" className="w-11 h-11 rounded-full object-cover border-2 border-amber-400" />
            ) : (
              <div className="w-11 h-11 rounded-full flex items-center justify-center bg-amber-100 border-2 border-amber-400 font-bold" style={{ color: "#7c2d12" }}>
                {(it.name || "?").slice(0, 1).toUpperCase()}
              </div>
            )}
            <div>
              <div className="font-semibold text-sm" style={{ color: "#7c2d12" }}>
                {KIND_EMOJI[it.kind] || "🎉"} {it.name}
              </div>
              <div className="text-[10px] uppercase tracking-widest" style={{ color: "#9a3412" }}>
                {KIND_LABEL[it.kind] || "Celebration"}
                {it.kind === "work_anniversary" && it.years ? ` · ${it.years} year${it.years === 1 ? "" : "s"}` : ""}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
